










































import AdUnit from "@/models/adUnit";
import {
  AvailabilityFilterModel,
  AvailabilityNode,
} from "@/models/availability";
import Site from "@/models/site";
import { Component, Vue, Prop, Watch } from "vue-property-decorator";
import AvailabilityLayout from "./AvailabilityLayout.vue";
import { AVALABILITY_LAYOUT } from "@/constants/availability_layout";
import { get } from "lodash";
import Campaign, { LineItem } from "@/models/campaign";
import { LineItemModule } from "@/store/lineItem";
import CampaignsAPI from "@/services/campaigns";
import { QueryParams } from "@/models/general";
import moment from "moment";
import { LayoutModule } from "@/store/layout";
import { DefinitionList } from "@/models/definition";
import DefinitionValue from "@/models/definitionValue";

@Component({
  components: { AvailabilityLayout },
})
export default class VisualAvailability extends Vue {
  @Prop({ default: () => [] }) sites!: Site[];
  @Prop({ default: () => [] }) adUnits!: AdUnit[];
  @Prop({ default: () => [] }) campaigns!: Campaign[];
  @Prop({ default: () => [] }) definitions!: DefinitionList[];
  @Prop({ default: undefined }) filter: AvailabilityFilterModel | undefined;
  lineItems: LineItem[] = [];
  panel = [0];
  dataLoaded = false;
  selectedCountry = "";

  get layout(): any {
    const site_id = this.filter ? (this.filter.site_id as string) : "";
    return get(AVALABILITY_LAYOUT, `sites.${site_id}`);
  }

  get site(): Site {
    const id = this.filter ? this.filter.site_id : "";
    const site = this.sites.find((s) => s.id === id);
    return site ? site : new Site();
  }

  get siteSections(): AvailabilityNode[] {
    const sections = this.site.availabilityLayout
      ? this.site.availabilityLayout[0].children
      : ([] as AvailabilityNode[]);

    return sections as AvailabilityNode[];
  }

  get countries(): DefinitionValue[] {
    let definitions: DefinitionValue[] = [];
    this.definitions.forEach((d) => {
      if (d.value === "country") {
        definitions = d.values;
      }
    });

    definitions = definitions.filter((d) => {
      const e = this.adUnits.find((a) => {
        return a.definitionValueIds.includes(d.id as string);
      });

      return e ? true : false;
    });

    definitions = definitions.sort((a, b) => {
      return a.name.localeCompare(b.name, undefined, {
        numeric: true,
        sensitivity: "base",
      });
    });

    return definitions;
  }

  created(): void {
    this.getLineItems();
  }

  @Watch("filter", { deep: true })
  onFilterChange(): void {
    this.getLineItems();
  }

  async getLineItems(): Promise<void> {
    this.dataLoaded = false;
    LayoutModule.showLoader();
    try {
      const now = moment().toDate();
      const params: QueryParams = {
        page: {
          size: -1,
        },
        filter: {
          site_id: this.site.id,
          start: now,
          end: now,
        },
      };

      const r = await CampaignsAPI.lineItems.all(params);

      this.lineItems = r.data;
    } catch (e) {
      //
    }
    LayoutModule.hideLoader();
    this.dataLoaded = true;
  }

  composeAdUnitName(s: string): string | undefined {
    const name = s ? s.split(" ") : [];
    return name.pop();
  }

  composeSectionName(l: any): string {
    let adunitName = "";
    try {
      adunitName = l["CONT"][0].name;
    } catch (e) {
      adunitName = l["RGT"][0].name;
    }
    let name = adunitName.split(" ");
    name.pop();

    return name.join(" ");
  }
}
